import {
  initTomSelect,
  initTomMultiCheckboxSelect,
  initInputMaskByKey,
  initIntlTelInput,
} from '%helpers%/helpers';

const bindFormSubmitHandlers = () => {
  // Handle multi-step form buttons
  const multiStepForms = document.querySelectorAll('.multi-step-form');

  multiStepForms.forEach(formWrapper => {
    // Previous button
    formWrapper.addEventListener('click', e => {
      const target = e.target.closest('[name=__prev]');
      if (target) {
        e.preventDefault();
        const form = target.closest('form');
        window.clickedButton = 'prev';
        form.requestSubmit();
        target.dispatchEvent(new Event('form-back', {bubbles: true}));
        target.setAttribute('disabled', 'disabled');
      }
    });

    // Next button
    formWrapper.addEventListener('click', e => {
      const target = e.target.closest('[name=__next]');
      if (target) {
        e.preventDefault();
        const form = target.closest('form');
        window.clickedButton = 'primary';
        form.requestSubmit();
        target.setAttribute('disabled', 'disabled');
      }
    });
  });

  // Multi-step form submission
  document.querySelectorAll('.multi-step-form form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();

      const currentNodePageUrl = document.querySelector('#pageInfoDiv')?.dataset.url;
      const umbracoFormsForm = form.closest('.umbraco-forms-form');
      const widgetFormContent = form.closest('.widget-form-content');
      const formId = umbracoFormsForm?.id;
      const formData = new FormData(form);
      const isPreviousClicked = window.clickedButton === 'prev';
      if (isPreviousClicked) {
        formData.append('__prev', 'Previous');
      }
      window.clickedButton = '';

      if (!form.dataset.submitted && form.checkValidity()) {
        form.dataset.submitted = 'true';
        document.body.classList.add('loading');

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: formData,
          });
          const html = await response.text();

          const parser = new DOMParser();
          const resultDoc = parser.parseFromString(html, 'text/html');

          let thankYouMessage =
            resultDoc.querySelector('.umbraco-forms-submitmessage') ||
            resultDoc.querySelector('.umbraco-forms-submitmessage-html');

          const errors = resultDoc.querySelectorAll(`#${formId} .field-validation-error`);
          const submitLastPage = form.querySelector('.multipage-lastpage');
          const resultNodePageUrl = resultDoc.querySelector('#pageInfoDiv')?.dataset.url;
          const resultStep = resultDoc.querySelector(`#${formId} input[name="FormStep"]`)?.value;
          const currentStep = form.querySelector('input[name="FormStep"]')?.value;
          const recordState = resultDoc.querySelector(`#${formId} input[name="RecordState"]`)?.value;
          const token = resultDoc.querySelector(`#${formId} input[name="__RequestVerificationToken"]`)?.value;
          const ufprt = resultDoc.querySelector(`#${formId} input[name="ufprt"]`)?.value;
          const id = resultDoc.querySelector('.umbraco-forms-page')?.id;

          if (resultStep) form.querySelector('input[name="FormStep"]').value = resultStep;
          if (recordState) form.querySelector('input[name="RecordState"]').value = recordState;
          if (token) form.querySelector('input[name="__RequestVerificationToken"]').value = token;
          if (ufprt) form.querySelector('input[name="ufprt"]').value = ufprt;
          if (id) form.querySelector('.umbraco-forms-page').id = id;

          if (isPreviousClicked) {
            form.dataset.submitted = '';
            const visible = getVisibleElement('.umbraco-forms-custom-class', form);
            if (visible) visible.remove();

            const replacement = resultDoc.querySelector(
              `#${formId}.multi-step-form form .umbraco-forms-custom-class`
            );

            if (replacement) {
              const target = form.querySelector(`.umbraco-forms-custom-class[data-step="${resultStep}"]`);
              if (target) {
                target.style.display = 'block';
                target.innerHTML = replacement.innerHTML;
                initiateFormElements(target);
              }
            }
          } else if (errors.length > 0) {
            form.dataset.submitted = '';

            const replacement = resultDoc.querySelector(
              `#${formId}.multi-step-form form .umbraco-forms-custom-class`
            );

            if (replacement) {
              const visible = getVisibleElement('.umbraco-forms-custom-class', form);
              if (visible) {
                visible.innerHTML = replacement.innerHTML;
                initiateFormElements(visible);
              }
            }
          } else if (resultNodePageUrl && resultNodePageUrl !== currentNodePageUrl) {
            form.dataset.submitted = 'true';
            window.location.href = resultNodePageUrl;
          } else if (thankYouMessage) {
            form.dataset.submitted = 'true';
            form.innerHTML = thankYouMessage.outerHTML;
            form.closest('.umbraco-forms-form').previousElementSibling?.classList.add('d-none');
            window.scrollTo({
              top:
                form.getBoundingClientRect().top +
                window.scrollY -
                document.querySelector('header').offsetHeight,
              behavior: 'smooth',
            });
          } else if (submitLastPage) {
            form.dataset.submitted = '';
            window.location.href = resultNodePageUrl;
          } else {
            form.dataset.submitted = '';
            form.querySelectorAll('.umbraco-forms-custom-class').forEach(el => (el.style.display = 'none'));
            const replacement = resultDoc.querySelector(
              `#${formId}.multi-step-form form .umbraco-forms-custom-class`
            );
            if (replacement) {
              replacement.classList.add('page-' + currentStep);
              form.querySelector('.umbraco-forms-page').appendChild(replacement);
              initiateFormElements(replacement);
            }
          }
          window.UmbracoForms.reinitConditions(widgetFormContent);
        } catch (err) {
          console.error('Single-step form error:', err);
        } finally {
          document.body.classList.remove('loading');
        }
      }
    });
  });

  document.querySelectorAll('.single-step-form form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      document.body.classList.add('loading');
      const umbracoFormsForm = form.closest('.umbraco-forms-form');
      const formId = umbracoFormsForm?.id;
      const widgetFormContent = form.closest('.widget-form-content');

      if (!form.dataset.submitted && form.checkValidity()) {
        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
          });
          const html = await response.text();

          const parser = new DOMParser();
          const resultDoc = parser.parseFromString(html, 'text/html');

          let thankYouMessage =
            resultDoc.querySelector('.umbraco-forms-submitmessage') ||
            resultDoc.querySelector('.umbraco-forms-submitmessage-html');
          const resultNodePageUrl = resultDoc.querySelector('#pageInfoDiv')?.dataset.url;
          const errors = resultDoc.querySelectorAll(`#${formId} .field-validation-error`);

          if (errors.length > 0) {
            form.dataset.submitted = '';

            const replacement = resultDoc.querySelector(
              `#${formId}.single-step-form form .umbraco-forms-custom-class`
            );

            if (replacement) {
              const visible = getVisibleElement('.umbraco-forms-custom-class', form);
              if (visible) {
                visible.innerHTML = replacement.innerHTML;
                initiateFormElements(visible);
              }
            }

            window.UmbracoForms.reinitConditions(widgetFormContent);
          } else if (thankYouMessage) {
            form.dataset.submitted = 'true';
            form.innerHTML = thankYouMessage.outerHTML;
            form.closest('.umbraco-forms-form').previousElementSibling?.classList.add('d-none');
            window.scrollTo({
              top:
                form.getBoundingClientRect().top +
                window.scrollY -
                document.querySelector('header').offsetHeight,
              behavior: 'smooth',
            });
          } else if (resultNodePageUrl) {
            window.location.href = resultNodePageUrl;
          }
        } catch (err) {
          console.error('Single-step form error:', err);
        } finally {
          document.body.classList.remove('loading');
        }
      }
    });
  });
};

function getVisibleElement(selector, root = document) {
  const elements = root.querySelectorAll(selector);
  return Array.from(elements).find(el => el.offsetParent !== null) || null;
}

const removeDuplicateFormsFromDOM = () => {
  const found = {};
  document.querySelectorAll('.form-wrapper[data-form-id]').forEach(el => {
    const formId = el.getAttribute('data-form-id');
    if (found[formId]) {
      el.remove();
    } else {
      found[formId] = true;
    }
  });
};

function initiateFormElements(selector) {
  if (selector) {
    selector.querySelectorAll('input[data-mask]:not(.js-input)').forEach(el => {
      initInputMaskByKey(el, el.getAttribute('data-mask'));
    });

    selector.querySelectorAll('select.js-select').forEach(el => {
      if (el.multiple) initTomMultiCheckboxSelect(el);
      else initTomSelect(el, {searchEnabled: true});
    });

    selector.querySelectorAll('.js-intlTel').forEach(input => {
      initIntlTelInput(input);
    });

    selector.querySelectorAll('.google-autocomplete').forEach(async el => {
      await initGoogleAutocompleteUmbracoForms(el);
    });

    selector.querySelectorAll('.span-tooltip').forEach(el => {
      bootstrap.Tooltip.getOrCreateInstance(el, {
        placement: 'top',
        trigger: 'hover',
      });
    });
  }
}

async function initGoogleAutocompleteUmbracoForms(el) {
  if (!el) return;
  const fieldsJson = el.getAttribute('data-mapped-fields');

  const {Autocomplete} = await google.maps.importLibrary('places');

  const autocomplete = new Autocomplete(el, {
    fields: ['address_components'],
    types: ['address'],
    componentRestrictions: {country: ['us']},
  });
  if (fieldsJson) {
    // Mapping fields from Umbraco
    const form = el.closest('form');
    let mappedFields = [];

    if (fieldsJson) {
      try {
        mappedFields = JSON.parse(fieldsJson);
      } catch {
        mappedFields = [];
      }
    }

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!place || !place.address_components) return;

      const components = {};
      for (const comp of place.address_components) {
        if (comp.types.includes('street_number')) components.street = comp.long_name;
        if (comp.types.includes('route')) components.route = comp.long_name;
        if (comp.types.includes('locality')) components.city = comp.long_name;
        if (comp.types.includes('administrative_area_level_1')) {
          components.state = comp.long_name;
          components.stateValue = comp.short_name;
        }
        if (comp.types.includes('country')) components.country = comp.long_name;
        if (comp.types.includes('postal_code')) components.postcode = comp.long_name;
        if (comp.types.includes('administrative_area_level_2')) components.county = comp.long_name;
      }

      const street = (components.street ? components.street + ' ' : '') + (components.route || '');

      mappedFields.forEach(field => {
        const target = form.querySelector(`input[name="${field.value}"], select[name="${field.value}"]`);
        if (!target) return;

        switch (field.alias) {
          case 'Street Address':
            target.value = street;
            break;
          case 'Country':
            target.value = components.country || '';
            break;
          case 'County':
            target.value = components.county?.replace(/ county$/i, '') || '';
            break;
          case 'State':
            if (target.tagName.toLowerCase() === 'select') {
              const ts = target.tomselect;

              if (Array.isArray(target.value)) {
                ts.setValue(components.stateValue || '', true);
              } else {
                ts.setValue(components.stateValue || '', true);
              }
              return;
            } else {
              target.value = components.state || '';
            }
            break;
          case 'City':
            target.value = components.city || '';
            break;
          case 'Zip Code':
            target.value = components.postcode || '';
            break;
        }
      });
    });
  }
}

const initializeHandleUmbracoFormsAjax = () => {
  removeDuplicateFormsFromDOM();
  bindFormSubmitHandlers();

  document.querySelectorAll('form .google-autocomplete').forEach(async el => {
    await initGoogleAutocompleteUmbracoForms(el);
  });

  const modalElement = document.getElementById('seeMyOfferModal');
  const modalBody = modalElement.querySelector('.widget-form-content');

  let currentForm = null;
  let originalParent = null;

  document.querySelectorAll('.modal-form-init').forEach(button => {
    button.addEventListener('click', function () {
      const formId = this.dataset.formId;

      currentForm = document.querySelector(`.partial-form[data-form-id="${formId}"]`);

      if (!currentForm) return;

      originalParent = currentForm.parentElement;

      modalBody.appendChild(currentForm);

      const headerContent = this.dataset.formHeader;
      if (headerContent) {
        const title = modalElement.querySelector('.modal-title');
        if (title) {
          title.innerHTML = headerContent;
          title.classList.remove('visually-hidden');
        }
      }

      const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
      modal.show();
    });
  });

  modalElement.addEventListener('hidden.bs.modal', function () {
    if (currentForm && originalParent) {
      originalParent.appendChild(currentForm);
    }

    currentForm = null;
    originalParent = null;

    modalBody.innerHTML = '';
  });
};

export {initializeHandleUmbracoFormsAjax};
